module.exports = __webpack_public_path__ + "img/20240914_1.b3bfe4a9.jpg";